import classNames from 'classnames'
import React, { PropsWithChildren } from 'react'
import { Grid } from './Grid'

export interface MarketSectionProps {
  additionalClassName?: string
  applyGrid?: boolean
  id?: string
}

/**
 * Market sections don't use margins due to them potentially containing components using css parallax
 * (MarketParallaxHero). This means we can't use margin collapsing, so use css next-sibling logic instead.
 */
export const MarketSection = ({
  additionalClassName,
  applyGrid = true,
  children,
  id,
}: PropsWithChildren<MarketSectionProps>) => {
  const className = classNames(
    'py-60 bg-neutral blockmargin next-sibling-[blockmargin]:pt-0 first:pt-0 last:pb-0',
    'sm:py-90 sm:next-sibling-[blockmargin]:pt-0',
    'lg:py-120 lg:next-sibling-[blockmargin]:pt-0',
    additionalClassName
  )

  return applyGrid ? (
    <Grid additionalClassName={className} as="section" id={id}>
      {children}
    </Grid>
  ) : (
    <section className={className} id={id}>
      {children}
    </section>
  )
}
